import { useContext } from "react";
import { ASGContext, IASGContext } from "@ottomotors/ottomotors.com/context";

export const useASG = (): IASGContext => useContext(ASGContext);

export default useASG;
